import { Card, CardBody,  Collapse } from "reactstrap";
import { useState } from "react";
import HeaderWithIcon from "../HeaderWithIcon";
import { Friends } from "../../../../Constant";
import { FRIENDS_IMAGES } from "../../../../Data/SocialApp";
import { Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";

const FriendsCard = () => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Card>
      <HeaderWithIcon Heading={Friends} isOpen={isOpen} setIsOpen={setIsOpen}/>
      <Collapse isOpen={isOpen}>
        <CardBody className="avatar-showcase filter-cards-view">
          {FRIENDS_IMAGES.map((data, index) => (
            <div className="d-inline-block friend-pic" key={index}>
              <Image className="img-50 rounded-circle" src={dynamicImage(`user/${data}`)} alt="images"/>
            </div>
          ))}
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default FriendsCard;
